const path = window.location.pathname.replace(/\/+$/, '');
const isWishlistPath = path === '/apps/page/wishlist' || path === '/apps/wishlist';

function normalizeText(el) {
  return (el?.textContent || '').replace(/\s+/g, ' ').trim();
}

function findWishlistRoot() {
  const main = document.querySelector('#main');
  if (!main) return null;

  const heading = Array.from(main.querySelectorAll('h1,h2,h3')).find(
    (el) => normalizeText(el).toLowerCase() === 'wishlist'
  );
  if (!heading) return null;

  let node = heading.parentElement;
  let best = node;

  while (node && node !== main) {
    const text = normalizeText(node).toLowerCase();
    const hasWishlistAction = /add to cart|share|wishlist/.test(text);
    if (hasWishlistAction) best = node;
    if (node.children.length > 8) break;
    node = node.parentElement;
  }

  return best || heading.parentElement;
}

function enhanceWishlist() {
  if (!isWishlistPath) return;

  document.body.classList.add('indie-wishlist-page');

  const root = findWishlistRoot();
  if (!root) return;
  root.classList.add('indie-wishlist-root');

  const heading = Array.from(root.querySelectorAll('h1,h2,h3')).find(
    (el) => normalizeText(el).toLowerCase() === 'wishlist'
  );
  heading?.classList.add('indie-wishlist-title');

  // Hide only the introductory marketing copy; keep wishlist products and empty state.
  const introPattern = /^save your favourites and come back to them anytime[.!]?$/i;
  const introCandidates = Array.from(root.querySelectorAll('*')).filter(
    (el) => introPattern.test(normalizeText(el))
  );
  const intro = introCandidates.find(
    (el) => !Array.from(el.children).some((child) => introPattern.test(normalizeText(child)))
  );
  intro?.classList.add('indie-wishlist-intro-copy');

  Array.from(root.querySelectorAll('button,a')).forEach((el) => {
    const text = normalizeText(el).toLowerCase();
    const label = (el.getAttribute('aria-label') || '').toLowerCase();
    const title = (el.getAttribute('title') || '').toLowerCase();

    if (text === 'add to cart') {
      el.classList.add('indie-wishlist-add');
    } else if (text === 'add all to cart') {
      el.classList.add('indie-wishlist-add-all');
    }

    if (text === '×' || text === 'x' || /remove|delete/.test(label + ' ' + title)) {
      el.classList.add('indie-wishlist-remove');
    }
  });

  const addButtons = Array.from(root.querySelectorAll('.indie-wishlist-add'));
  const cards = [];

  addButtons.forEach((button) => {
    let node = button.parentElement;
    let card = null;

    while (node && node !== root) {
      if (node.querySelector('img') && node.contains(button)) {
        card = node;
        const childButtons = node.querySelectorAll('.indie-wishlist-add').length;
        if (childButtons === 1) break;
      }
      node = node.parentElement;
    }

    if (card && !cards.includes(card)) {
      card.classList.add('indie-wishlist-card');
      cards.push(card);

      const image = card.querySelector('img');
      if (image) {
        image.classList.add('indie-wishlist-image');
        const imageWrap = image.parentElement;
        imageWrap?.classList.add('indie-wishlist-image-wrap');
      }
    }
  });

  if (cards.length) {
    const commonParent = cards.reduce((parent, card) => {
      if (!parent) return card.parentElement;
      return parent === card.parentElement ? parent : null;
    }, null);

    commonParent?.classList.add('indie-wishlist-grid');
  }

  const shareText = Array.from(root.querySelectorAll('*')).find(
    (el) => el.children.length === 0 && normalizeText(el).toLowerCase() === 'share'
  );
  shareText?.parentElement?.classList.add('indie-wishlist-share');

  const allText = normalizeText(root).toLowerCase();
  if (/no items|empty wishlist|wishlist is empty|no products/.test(allText)) {
    root.classList.add('indie-wishlist-empty');
  }
}

if (isWishlistPath) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceWishlist, { once: true });
  } else {
    enhanceWishlist();
  }

  const observer = new MutationObserver(() => enhanceWishlist());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 8000);
}